import Stack from "../services/contentstack";

export const getFooterRes = async (entryUrl, referenceFieldPath, jsonRtePath) => {
    const response = await Stack.getEntryByUrl({
      contentTypeUid: 'footer',
      entryUrl,
      referenceFieldPath: referenceFieldPath || [],
      jsonRtePath: jsonRtePath || [],
    });
    // liveEdit && addEditableTags(response[0], 'page', true);
    return response[0];
  };